import { api } from './api';
import { LoginRequest, LoginResponse, UserInfo } from '../types';

export const authService = {
  login: async (email: string, password: string): Promise<{ token: string; user: UserInfo }> => {
    try {
      const loginData: LoginRequest = {
        Email: email,
        Password: password,
      };

      const response = await api.post<any>('users/login', loginData);

      if (response.data && response.data.token) {
        // Normalise les champs : l'API peut retourner role ou Role, id ou Id, etc.
        const raw = response.data.user || response.data;
        const user: UserInfo = {
          Id: raw.Id ?? raw.id ?? 0,
          FirstName: raw.FirstName ?? raw.firstName ?? '',
          LastName: raw.LastName ?? raw.lastName ?? '',
          Email: raw.Email ?? raw.email ?? '',
          Role: raw.Role ?? raw.role ?? '',
        };
        return { token: response.data.token, user };
      }

      throw new Error('Token non reçu du serveur');
    } catch (error: any) {
      if (error.response?.status === 401 || error.response?.status === 400) {
        throw new Error('Identifiants incorrects');
      }
      throw new Error('Erreur de connexion au serveur');
    }
  },

  logout: (): void => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getToken: (): string | null => {
    return localStorage.getItem('token');
  },

  setToken: (token: string): void => {
    localStorage.setItem('token', token);
  },

  getUser: (): UserInfo | null => {
    const stored = localStorage.getItem('user');
    if (!stored) return null;
    try {
      return JSON.parse(stored) as UserInfo;
    } catch {
      return null;
    }
  },

  setUser: (user: UserInfo): void => {
    localStorage.setItem('user', JSON.stringify(user));
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('token');
  },
};
